import React, { useContext, useRef, useState } from "react";
import Feedback from "./Feedback";
import Button from "../../../../Button";
import Textarea from "../../../../CommonComponents/Textarea";
import { useEffect } from "react";
import Checkbox from "../../../../CommonComponents/Checkbox";
import { nanoid } from "nanoid";
import useAxiosPrivate from "../../../../../Hooks/useAxiosPrivate";
import useCommonFunctionHooks from "../../../../../Hooks/useCommonFunctionHooks";
import AlertContext from "../../../../../context/AlertContext";
import { getDataFromStorage } from "../../../../../util";
import useS3FileManagement from "../../../../../Hooks/useS3FileManagement";
import Modal from "../../../../CommonComponents/Modal";
import { UserReportContext } from "../../../../../context/UserReportContext";
import DragAndDropUpload from "../../../../CommonComponents/DragAndDropUpload";
import StudentsRemarksSkeleton from "./StudentsRemarksSkeleton";
import { useParams } from "react-router-dom";
import Toast from "../../../../CommonComponents/Toast";
import Slide from "@mui/material/Slide";
import { ProfileContext } from "../../../../../context/ProfileContext";

const StudentsRemarks = ({
  studentData,
  clearAllState,
  from,
  id,
  batch_id,
  className = "",
}) => {
  // console.log("studentData:", studentData);
  // console.log("feedback api resonponse:", feedBacks);
  const { id: bid } = useParams();
  const company_id = getDataFromStorage("companyId");
  const fileInputRef = useRef(null);
  const axios = useAxiosPrivate();
  const Alert = useContext(AlertContext);
  const useCommonFunctionHks = useCommonFunctionHooks();
  const [keys, setKeys] = useState([]);
  const { onUploadS3Object, getPreSignedUrl } = useS3FileManagement();
  const [isFeedbackLoaded, setIsFeedbackLoaded] = useState(false);
  const [addFeedAttachmentForm, setAddFeedAttachmentForm] = useState(false);
  const [attachments, setAttachments] = useState([]);
  const [message, setMessage] = useState("");
  const [feedBacks, setFeedBacks] = useState([]);
  const [postLoading, setPostingLoading] = useState(false);
  const [selectedCheckboxValue, setSelectedCheckboxValue] = useState({
    student: false,
    parent: false,
  });
  const UserReportCxt = useContext(UserReportContext);
  const [toastMessage, setToastMessage] = useState({
    message: "",
    icon: (
      <svg
        width="46"
        height="46"
        viewBox="0 0 46 46"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect x="3" y="3" width="40" height="40" rx="20" fill="#D1FADF" />
        <rect
          x="3"
          y="3"
          width="40"
          height="40"
          rx="20"
          stroke="#ECFDF3"
          stroke-width="6"
        />
        <g clip-path="url(#clip0_1393_14704)">
          <path
            d="M20.5003 23L22.167 24.6667L25.917 20.9167M19.1118 16.1822C19.7817 16.1288 20.4176 15.8654 20.929 15.4295C22.1226 14.4124 23.8781 14.4124 25.0716 15.4295C25.5831 15.8654 26.219 16.1288 26.8889 16.1822C28.452 16.307 29.6933 17.5483 29.8181 19.1115C29.8715 19.7813 30.1349 20.4173 30.5708 20.9287C31.5879 22.1223 31.5879 23.8777 30.5708 25.0713C30.1349 25.5827 29.8715 26.2187 29.8181 26.8885C29.6933 28.4517 28.452 29.693 26.8889 29.8178C26.219 29.8712 25.5831 30.1346 25.0716 30.5705C23.8781 31.5876 22.1226 31.5876 20.929 30.5705C20.4176 30.1346 19.7817 29.8712 19.1118 29.8178C17.5486 29.693 16.3073 28.4517 16.1826 26.8885C16.1291 26.2187 15.8657 25.5827 15.4298 25.0713C14.4127 23.8777 14.4127 22.1223 15.4298 20.9287C15.8657 20.4173 16.1291 19.7813 16.1826 19.1115C16.3073 17.5483 17.5486 16.307 19.1118 16.1822Z"
            stroke="#039855"
            stroke-width="1.66667"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_1393_14704">
            <rect
              width="20"
              height="20"
              fill="white"
              transform="translate(13 13)"
            />
          </clipPath>
        </defs>
      </svg>
    ),
  });
  function SlideTransition(props) {
    return <Slide {...props} direction="left" />;
  }
  const [toastOpen, setToastOpen] = useState({
    open: false,
    vertical: "top",
    horizontal: "center",
    Transition: SlideTransition,
  });
  const { vertical, horizontal, open, Transition } = toastOpen;
  const { setIsLoaded, setShowNotify, setClickedMenu } =
    useContext(AlertContext);

  useEffect(() => {
    const fetchFeedbackData = async (learnerId) => {
      console.log("function calling");
      setIsFeedbackLoaded(true);
      try {
        const response = await axios.get(
          `/node/admin/studentremarks?id=${learnerId}&batchid=${
            batch_id ?? bid ?? null
          }&company_id=${company_id ?? localStorage.getItem("companyId")}`,
          useCommonFunctionHks.getHeaderDetailsForAxios()
        );
        console.log("response from api:", response);
        if (response.data.resultCode !== 1000) {
          Alert.setShowNotify({
            show: true,
            title: "Info",
            msg: response.data.error,
          });
          throw new Error(
            "Something went wrong while fetching feedback of the student"
          );
        }
        let feedback = response.data.learnerRemarksInfo;

        for (let i = 0; i < feedback.length; i++) {
          if (feedback[i].file_url) {
            let urls = feedback[i].file_url.split(",");
            let fileTypeArr = [];
            let fileNameArr = [];
            for (let j = 0; j < urls.length; j++) {
              const url = urls[j].trim();
              fileTypeArr.push(url.split(".").pop());
              fileNameArr.push(url.split(".")[0].split("/").pop());
              // console.log("urls:", urls, "fileTypeArr:", fileTypeArr);
            }
            feedback[i].file_link = await getPreSignedUrl(
              urls,
              undefined,
              fileTypeArr,
              "GET"
            );
            // console.log("fileNameArr:", fileNameArr);

            feedback[i].file_name = fileNameArr;
          }
        }
        // console.log("response from api>>>s>>>>>>feedback:", feedback);

        setFeedBacks(feedback);
        setIsFeedbackLoaded(false);
      } catch (error) {
        setIsFeedbackLoaded(false);
        console.log("error", error);
      }
    };

    fetchFeedbackData(id);
  }, [setShowNotify, from, id]);

  const handleAddAttachments = (event) => {
    let commentedDate = String(new Date());
    let newAttachment = [...attachments];
    let files = Array.from(event.target.files);

    for (let i = 0; i < files.length; i++) {
      let attachment = { id: nanoid(), file: files[i], date: commentedDate };
      newAttachment.push(attachment);
    }
    setAttachments(newAttachment);
    event.target.value = "";
  };
  const handleDeleteAttachments = (attachmentId) => {
    setAttachments((prevAttachment) =>
      prevAttachment.filter((attachment) => attachment.id !== attachmentId)
    );
  };

  const creatorId = getDataFromStorage("learnerid");

  const getVisibleStatus = () => {
    if (selectedCheckboxValue.student && selectedCheckboxValue.parent) {
      return 3;
    } else if (selectedCheckboxValue.student) {
      return 1;
    } else if (selectedCheckboxValue.parent) {
      return 2;
    } else {
      return 0;
    }
  };
  const postFeedback = async () => {
    try {
      setPostingLoading(true);
      console.log("message:", message, "attachments:", attachments);
      let attachment = [];
      let time = new Date();
      attachments.map((at) =>
        attachment.push(
          `${at.file.name.split(".")[0]}_${time.getTime()}.${
            at.file.name.split(".")[1]
          }`
        )
      );

      const response = await axios.post(
        `/node/admin/studentremarks`,
        {
          feedback: message,
          visible_to: getVisibleStatus(),
          attachmentsFileName: attachment,
          learner_id: studentData?.userId ?? id,
          created_by: creatorId,
          company_id: getDataFromStorage("companyId"),
          bid: bid,
        },
        useCommonFunctionHks.getHeaderDetailsForAxios()
      );
      console.log("response:", response, "visible status:", getVisibleStatus());

      if (response.data.resultCode !== 1000) {
        setToastMessage((prev) => ({
          message: response.data?.error,
          icon: (
            <svg
              width="56"
              height="56"
              fill="none"
              viewBox="0 0 56 56"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                x="4"
                y="4"
                width="48"
                height="48"
                rx="24"
                fill={"#FEF0C7"}
              />
              <rect
                x="4"
                y="4"
                rx="24"
                width="48"
                height="48"
                stroke-width="8"
                stroke="#FFFBFA"
              />
              <path
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M27.9998 24.0012V28.0012M27.9998 32.0012H28.0098M26.2898 18.8612L17.8198 33.0012C17.6451 33.3036 17.5527 33.6465 17.5518 33.9957C17.5508 34.3449 17.6413 34.6883 17.8142 34.9917C17.9871 35.2951 18.2365 35.5479 18.5375 35.725C18.8385 35.9021 19.1806 35.9973 19.5298 36.0012H36.4698C36.819 35.9973 37.1611 35.9021 37.4621 35.725C37.7631 35.5479 38.0124 35.2951 38.1854 34.9917C38.3583 34.6883 38.4488 34.3449 38.4478 33.9957C38.4468 33.6465 38.3544 33.3036 38.1798 33.0012L29.7098 18.8612C29.5315 18.5673 29.2805 18.3243 28.981 18.1557C28.6814 17.987 28.3435 17.8984 27.9998 17.8984C27.656 17.8984 27.3181 17.987 27.0186 18.1557C26.7191 18.3243 26.468 18.5673 26.2898 18.8612Z"
                stroke={"#D92D20"}
              />
            </svg>
          ),
        }));

        setToastOpen({
          vertical: "top",
          horizontal: "right",
          open: true,
          Transition: SlideTransition,
        });
        throw new Error(
          response.data.error ||
            "Something went wrong while posting feedback of the student"
        );
      }
      setKeys(response?.data?.keys);

      if (
        attachment &&
        attachment.length >= 1 &&
        response?.data?.keys &&
        response?.data?.keys.length === 0
      ) {
        setToastMessage((prev) => ({
          message:
            "Image key is not generated and problem in saving to the database",
          icon: (
            <svg
              width="56"
              height="56"
              fill="none"
              viewBox="0 0 56 56"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                x="4"
                y="4"
                width="48"
                height="48"
                rx="24"
                fill={"#FEF0C7"}
              />
              <rect
                x="4"
                y="4"
                rx="24"
                width="48"
                height="48"
                stroke-width="8"
                stroke="#FFFBFA"
              />
              <path
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M27.9998 24.0012V28.0012M27.9998 32.0012H28.0098M26.2898 18.8612L17.8198 33.0012C17.6451 33.3036 17.5527 33.6465 17.5518 33.9957C17.5508 34.3449 17.6413 34.6883 17.8142 34.9917C17.9871 35.2951 18.2365 35.5479 18.5375 35.725C18.8385 35.9021 19.1806 35.9973 19.5298 36.0012H36.4698C36.819 35.9973 37.1611 35.9021 37.4621 35.725C37.7631 35.5479 38.0124 35.2951 38.1854 34.9917C38.3583 34.6883 38.4488 34.3449 38.4478 33.9957C38.4468 33.6465 38.3544 33.3036 38.1798 33.0012L29.7098 18.8612C29.5315 18.5673 29.2805 18.3243 28.981 18.1557C28.6814 17.987 28.3435 17.8984 27.9998 17.8984C27.656 17.8984 27.3181 17.987 27.0186 18.1557C26.7191 18.3243 26.468 18.5673 26.2898 18.8612Z"
                stroke={"#D92D20"}
              />
            </svg>
          ),
        }));

        setToastOpen({
          vertical: "top",
          horizontal: "right",
          open: true,
          Transition: SlideTransition,
        });
        // msg: "Image key is not generated and problem in saving to the database",

        clearAllState();
      }
      //upload attachments if any to s3
      try {
        for (let i = 0; i < attachments.length; i++) {
          console.log("attachments:", attachments[i]);
          console.log("keys:", keys[i], response?.data?.keys[i]);

          let res = await onUploadS3Object(
            response?.data?.keys[i],
            attachments[i].file,
            attachments[i].file.type.split("/")[1],
            undefined,
            "PUT"
          );
          console.log("res from uploading to aws....", res);
        }
      } catch (error) {
        throw new Error("Failed to upload in S3");
      }
      console.log("id:", id);

      setToastMessage((prev) => ({
        message: response.data?.msg,
        icon: (
          <svg
            width="46"
            height="46"
            viewBox="0 0 46 46"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect x="3" y="3" width="40" height="40" rx="20" fill="#D1FADF" />
            <rect
              x="3"
              y="3"
              width="40"
              height="40"
              rx="20"
              stroke="#ECFDF3"
              stroke-width="6"
            />
            <g clip-path="url(#clip0_1393_14704)">
              <path
                d="M20.5003 23L22.167 24.6667L25.917 20.9167M19.1118 16.1822C19.7817 16.1288 20.4176 15.8654 20.929 15.4295C22.1226 14.4124 23.8781 14.4124 25.0716 15.4295C25.5831 15.8654 26.219 16.1288 26.8889 16.1822C28.452 16.307 29.6933 17.5483 29.8181 19.1115C29.8715 19.7813 30.1349 20.4173 30.5708 20.9287C31.5879 22.1223 31.5879 23.8777 30.5708 25.0713C30.1349 25.5827 29.8715 26.2187 29.8181 26.8885C29.6933 28.4517 28.452 29.693 26.8889 29.8178C26.219 29.8712 25.5831 30.1346 25.0716 30.5705C23.8781 31.5876 22.1226 31.5876 20.929 30.5705C20.4176 30.1346 19.7817 29.8712 19.1118 29.8178C17.5486 29.693 16.3073 28.4517 16.1826 26.8885C16.1291 26.2187 15.8657 25.5827 15.4298 25.0713C14.4127 23.8777 14.4127 22.1223 15.4298 20.9287C15.8657 20.4173 16.1291 19.7813 16.1826 19.1115C16.3073 17.5483 17.5486 16.307 19.1118 16.1822Z"
                stroke="#039855"
                stroke-width="1.66667"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </g>
            <defs>
              <clipPath id="clip0_1393_14704">
                <rect
                  width="20"
                  height="20"
                  fill="white"
                  transform="translate(13 13)"
                />
              </clipPath>
            </defs>
          </svg>
        ),
      }));
      setToastOpen({
        vertical: "top",
        horizontal: "right",
        open: true,
        Transition: SlideTransition,
      });
      setAddFeedAttachmentForm(false);
    } catch (error) {
      console.log("error in fetching feedback:", error);
      setPostingLoading(false);
      setToastMessage((prev) => ({
        message: error.message,
        icon: (
          <svg
            width="56"
            height="56"
            fill="none"
            viewBox="0 0 56 56"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect x="4" y="4" width="48" height="48" rx="24" fill={"#FEF0C7"} />
            <rect
              x="4"
              y="4"
              rx="24"
              width="48"
              height="48"
              stroke-width="8"
              stroke="#FFFBFA"
            />
            <path
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M27.9998 24.0012V28.0012M27.9998 32.0012H28.0098M26.2898 18.8612L17.8198 33.0012C17.6451 33.3036 17.5527 33.6465 17.5518 33.9957C17.5508 34.3449 17.6413 34.6883 17.8142 34.9917C17.9871 35.2951 18.2365 35.5479 18.5375 35.725C18.8385 35.9021 19.1806 35.9973 19.5298 36.0012H36.4698C36.819 35.9973 37.1611 35.9021 37.4621 35.725C37.7631 35.5479 38.0124 35.2951 38.1854 34.9917C38.3583 34.6883 38.4488 34.3449 38.4478 33.9957C38.4468 33.6465 38.3544 33.3036 38.1798 33.0012L29.7098 18.8612C29.5315 18.5673 29.2805 18.3243 28.981 18.1557C28.6814 17.987 28.3435 17.8984 27.9998 17.8984C27.656 17.8984 27.3181 17.987 27.0186 18.1557C26.7191 18.3243 26.468 18.5673 26.2898 18.8612Z"
              stroke={"#D92D20"}
            />
          </svg>
        ),
      }));

      setToastOpen({
        vertical: "top",
        horizontal: "right",
        open: true,
        Transition: SlideTransition,
      });
    }
  };
  const handlePublishFeedback = () => {
    postFeedback();
  };
  const supportedFormat = ["jpg", "jpeg", "png"];

  const uploadFiles = (files = [], event) => {
    const isUploadableFormat = files.every((file) =>
      supportedFormat.includes(file.type.split("/")[1])
    );
    if (!isUploadableFormat) return;
    let commentedDate = String(new Date());
    let newAttachment = [...attachments];
    let files1 = Array.from(event.target.files);

    for (let i = 0; i < files1.length; i++) {
      let attachment = { id: nanoid(), file: files1[i], date: commentedDate };
      newAttachment.push(attachment);
    }
    setAttachments(newAttachment);
  };
  const onUpload = (event) => {
    const files = Array.from(event.target.files);

    uploadFiles(files, event);
    event.target.value = "";
  };

  const handleClose = (event, reason) => {
    if (
      from === "reportfeedback" &&
      toastMessage.message === "Feedback added successfully"
    ) {
      clearAllState();
    }
    if (
      from === "onpopup" &&
      toastMessage.message === "Feedback added successfully"
    ) {
      Alert.setShowPopup(false);
    }
    setPostingLoading(false);
    setToastOpen({
      ...toastOpen,
      open: false,
    });
  };

  const canView = (feedback) => {
    const role = getDataFromStorage("role");

    if (role !== "parent" && role !== "learner") {
      return true; // admin/teacher/staff → show all
    }

    if (role === "parent") {
      return feedback.visible_to === 2 || feedback.visible_to === 3;
    }

    if (role === "learner") {
      return feedback.visible_to === 1 || feedback.visible_to === 3;
    }

    return false;
  };

  const normalizeLetters = (name) => {
    if (!name) return ""; // handle null/undefined/empty
    const trimmed = name.trim();
    return trimmed.charAt(0).toUpperCase() + trimmed.slice(1).toLowerCase();
  };

  return (
    <>
      <div className={`students-remark-container`}>
        <Toast
          open={open}
          message={toastMessage.message}
          autoHideDuration={3000}
          icon={toastMessage.icon}
          onClose={handleClose}
          closeIcon={
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M15 5L5 15M5 5L15 15"
                stroke="#667085"
                stroke-width="1.66667"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          }
          anchorOrigin={{ vertical: vertical, horizontal: horizontal }}
          key={vertical + horizontal}
          TransitionComponent={Transition}
        />
        {(from === "onpopup" || getDataFromStorage("role") === "learner") && (
          <div className="student-remark-header-popup">
            <div style={{ display: "flex", gap: "4px", alignItems: "center" }}>
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M7.50008 12.9167H6.25009C5.08711 12.9167 4.50563 12.9167 4.03246 13.0602C2.96713 13.3834 2.13345 14.217 1.81028 15.2824C1.66675 15.7555 1.66675 16.337 1.66675 17.5M12.0834 6.25C12.0834 8.32107 10.4045 10 8.33342 10C6.26235 10 4.58341 8.32107 4.58341 6.25C4.58341 4.17893 6.26235 2.5 8.33342 2.5C10.4045 2.5 12.0834 4.17893 12.0834 6.25ZM9.16675 17.5L11.7512 16.7616C11.875 16.7262 11.9369 16.7085 11.9946 16.682C12.0458 16.6585 12.0945 16.6298 12.14 16.5965C12.1912 16.5589 12.2367 16.5134 12.3277 16.4224L17.7085 11.0417C18.2838 10.4664 18.2838 9.53362 17.7084 8.95831C17.1331 8.38302 16.2004 8.38303 15.6251 8.95833L10.2444 14.339C10.1534 14.43 10.1079 14.4756 10.0703 14.5267C10.0369 14.5722 10.0082 14.6209 9.98471 14.6722C9.95821 14.7299 9.94053 14.7918 9.90516 14.9155L9.16675 17.5Z"
                  stroke={"#344054"}
                  stroke-width="1.6"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              Trainer Feedback
            </div>
            {(getDataFromStorage("role") === "trainer" ||
              getDataFromStorage("role") === "admin" ||
              getDataFromStorage("role") === "super_admin") && (
              <Button
                size="sm"
                onClick={(event) => {
                  event.preventDefault();
                  setAddFeedAttachmentForm(true);
                  console.log("Button clicked");
                }}
                hierarchy={{
                  type: "secondaryGrey",
                  buttonText: "Feedback",
                }}
                icon={{
                  type: "leading",
                  icon: (
                    <svg
                      width="14"
                      height="14"
                      viewBox="0 0 14 14"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M6.66829 0.834961V12.5016M0.834961 6.66829H12.5016"
                        stroke="#344054"
                        strokeWidth="1.67"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  ),
                }}
              />
            )}
          </div>
        )}
        <div className={`students-remark-feedback-container ${className}`}>
          {from !== "onpopup" &&
            getDataFromStorage("role") !== "parent" &&
            getDataFromStorage("role") !== "learner" && (
              <div className="student-remark-header">
                {`${
                  normalizeLetters(studentData?.firstname) ??
                  normalizeLetters(getDataFromStorage("name"))
                }`}
              </div>
            )}
          {isFeedbackLoaded ? (
            Array.from({ length: 6 }).map((_, i) => (
              <StudentsRemarksSkeleton key={i} />
            ))
          ) : feedBacks.length >= 1 ? (
            <>
              {feedBacks?.map((feedback) => {
                if (canView(feedback)) {
                  return (
                    <Feedback
                      key={feedback.id}
                      feedback={feedback}
                      setFeedBacks={setFeedBacks}
                      from={from}
                      className={className}
                      clearAllState={clearAllState}
                      toastOpen={toastOpen}
                      setToastOpen={setToastOpen}
                      setToastMessage={setToastMessage}
                      toastMessage={toastMessage}
                      onClose={handleClose}
                      SlideTransition={SlideTransition}
                    />
                  );
                } else {
                  return null;
                }
              })}
              <hr style={{ color: "#D0D5DD", opacity: "1" }}></hr>
            </>
          ) : (
            (getDataFromStorage("role") === "parent" ||
              getDataFromStorage("role") === "learner") && (
              <h4 className="students-remark-container-student-parent">
                No feedback to display
              </h4>
            )
          )}
        </div>
        {(getDataFromStorage("role") === "trainer" ||
          getDataFromStorage("role") === "admin" ||
          getDataFromStorage("role") === "super_admin") &&
          from !== "onpopup" && (
            <div className="students-remark-feedback-footer">
              <div className="students-remark-feedback-visible-header">
                Feedback visible for:
              </div>
              <div className="students-remark-feedback-visible-option">
                <Checkbox
                  text="Student"
                  checked={selectedCheckboxValue.student}
                  onChange={(checked) =>
                    setSelectedCheckboxValue((prev) => ({
                      ...prev,
                      student: checked,
                    }))
                  }
                />
                <Checkbox
                  text="Parent"
                  checked={selectedCheckboxValue.parent}
                  onChange={(checked) =>
                    setSelectedCheckboxValue((prev) => ({
                      ...prev,
                      parent: checked,
                    }))
                  }
                />
              </div>
              <div className="students-remark-feedback-textarea">
                <div className="student-remark-feedback-text-container">
                  <Textarea
                    placeholder="Write your feedback for your trainee."
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    className="feedbackicon"
                  />
                  <Button
                    size="sm"
                    onClick={() => fileInputRef.current.click()}
                    hierarchy={{
                      type: "secondaryGrey",
                      buttonText: "Add Attachment",
                    }}
                    destructive={false}
                    icon={{
                      type: "leading",
                      icon: (
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M17.5 12.5V15.8333C17.5 16.2754 17.3244 16.6993 17.0118 17.0118C16.6993 17.3244 16.2754 17.5 15.8333 17.5H4.16667C3.72464 17.5 3.30072 17.3244 2.98816 17.0118C2.67559 16.6993 2.5 16.2754 2.5 15.8333V12.5M14.1667 6.66667L10 2.5M10 2.5L5.83333 6.66667M10 2.5V12.5"
                            stroke="#344054"
                            stroke-width="1.67"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      ),
                    }}
                  />
                </div>
                <input
                  multiple
                  type="file"
                  accept="image/*"
                  onChange={handleAddAttachments}
                  ref={fileInputRef}
                />
              </div>
              <div className="student-feedback-attachments">
                {attachments &&
                  attachments?.map((attachment) => (
                    <div className="student-feedback-file-attachment-container">
                      <div className="student-feedback-file-attachment-icon">
                        <svg
                          width="12"
                          height="12"
                          viewBox="0 0 12 12"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g clip-path="url(#clip0_1244_3355)">
                            <path
                              d="M10.7201 5.52502L6.12514 10.12C5.56222 10.6829 4.79874 10.9992 4.00265 10.9992C3.20655 10.9992 2.44307 10.6829 1.88014 10.12C1.31722 9.5571 1.00098 8.79361 1.00098 7.99752C1.00098 7.20143 1.31722 6.43794 1.88014 5.87502L6.47514 1.28002C6.85043 0.904739 7.35942 0.693909 7.89014 0.693909C8.42087 0.693909 8.92986 0.904739 9.30515 1.28002C9.68043 1.6553 9.89126 2.16429 9.89126 2.69502C9.89126 3.22575 9.68043 3.73474 9.30515 4.11002L4.70514 8.70502C4.5175 8.89266 4.26301 8.99808 3.99764 8.99808C3.73228 8.99808 3.47779 8.89266 3.29014 8.70502C3.1025 8.51738 2.99709 8.26288 2.99709 7.99752C2.99709 7.73216 3.1025 7.47766 3.29014 7.29002L7.53514 3.05002"
                              stroke="#344054"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_1244_3355">
                              <rect width="12" height="12" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                        <div>{`${attachment.file.name.slice(0, 12)}...`}</div>
                      </div>
                      <svg
                        width="40"
                        height="40"
                        viewBox="0 0 40 40"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        onClick={() => {
                          handleDeleteAttachments(attachment.id);
                        }}
                      >
                        <g filter="url(#filter0_d_1385_1552)">
                          <rect
                            x="2"
                            y="1"
                            width="36"
                            height="36"
                            rx="8"
                            fill="white"
                          />
                          <rect
                            x="2.5"
                            y="1.5"
                            width="35"
                            height="35"
                            rx="7.5"
                            stroke="#FDA29B"
                          />
                          <path
                            d="M12.5 14H14.1667M14.1667 14H27.5M14.1667 14V25.6667C14.1667 26.1087 14.3423 26.5326 14.6548 26.8452C14.9674 27.1578 15.3913 27.3334 15.8333 27.3334H24.1667C24.6087 27.3334 25.0326 27.1578 25.3452 26.8452C25.6577 26.5326 25.8333 26.1087 25.8333 25.6667V14H14.1667ZM16.6667 14V12.3334C16.6667 11.8913 16.8423 11.4674 17.1548 11.1548C17.4674 10.8423 17.8913 10.6667 18.3333 10.6667H21.6667C22.1087 10.6667 22.5326 10.8423 22.8452 11.1548C23.1577 11.4674 23.3333 11.8913 23.3333 12.3334V14M18.3333 18.1667V23.1667M21.6667 18.1667V23.1667"
                            stroke="#B42318"
                            stroke-width="1.67"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </g>
                        <defs>
                          <filter
                            id="filter0_d_1385_1552"
                            x="0"
                            y="0"
                            width="40"
                            height="40"
                            filterUnits="userSpaceOnUse"
                            color-interpolation-filters="sRGB"
                          >
                            <feFlood
                              flood-opacity="0"
                              result="BackgroundImageFix"
                            />
                            <feColorMatrix
                              in="SourceAlpha"
                              type="matrix"
                              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                              result="hardAlpha"
                            />
                            <feOffset dy="1" />
                            <feGaussianBlur stdDeviation="1" />
                            <feColorMatrix
                              type="matrix"
                              values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
                            />
                            <feBlend
                              mode="normal"
                              in2="BackgroundImageFix"
                              result="effect1_dropShadow_1385_1552"
                            />
                            <feBlend
                              mode="normal"
                              in="SourceGraphic"
                              in2="effect1_dropShadow_1385_1552"
                              result="shape"
                            />
                          </filter>
                        </defs>
                      </svg>
                    </div>
                  ))}
              </div>
              <div className="students-remark-feedback-footer-button">
                <Button
                  size="sm"
                  onClick={handlePublishFeedback}
                  hierarchy={{
                    type: "primary",
                    buttonText: "Publish",
                  }}
                  disable={postLoading}
                />
              </div>
            </div>
          )}
      </div>

      <Modal
        centered
        showCloseIcon={false}
        isOpen={addFeedAttachmentForm}
        onClose={() => {
          console.log("closing the modal");
          setAddFeedAttachmentForm(false);
          setAttachments([]);
          setMessage("");
        }}
        className={"student-remarks"}
      >
        <div className="students-remark-feedback-footer">
          {"Student Feedback"}
          <div className="students-remark-feedback-footer-studentname">
            {normalizeLetters(UserReportCxt?.currentLearnerDetails?.label) ??
              normalizeLetters(getDataFromStorage("name"))}
          </div>
          <div className="students-remark-feedback-visible-header">
            Feedback visible for:
          </div>
          <div className="students-remark-feedback-visible-option">
            <Checkbox
              text="Student"
              checked={selectedCheckboxValue.student}
              onChange={(checked) =>
                setSelectedCheckboxValue((prev) => ({
                  ...prev,
                  student: checked,
                }))
              }
            />
            <Checkbox
              text="Parent"
              checked={selectedCheckboxValue.parent}
              onChange={(checked) =>
                setSelectedCheckboxValue((prev) => ({
                  ...prev,
                  parent: checked,
                }))
              }
            />
          </div>
          <div className="students-remark-feedback-textarea">
            <Textarea
              placeholder="Write your feedback for your trainee."
              value={message}
              onChange={(e) => setMessage(e.target.value)}
            />
            {/* <Button
              size="sm"
              onClick={() => fileInputRef.current.click()}
              hierarchy={{
                type: "secondaryGrey",
                buttonText: "Add Attachment",
              }}
            /> */}
            {/* <input
              multiple
              type="file"
              accept="image/*"
              onChange={handleAddAttachments}
              ref={fileInputRef}
            /> */}
          </div>
          <DragAndDropUpload
            onUpload={onUpload}
            file={attachments}
            isMultiUpload={true}
            uploadedFile={
              <UploadFile
                attachments={attachments}
                handleDeleteAttachments={handleDeleteAttachments}
              />
            }
            text="Drop your attachment"
          />
          <div className="students-remark-feedback-footer-button">
            <Button
              size="lg"
              onClick={() => {
                setAddFeedAttachmentForm(false);
                setAttachments([]);
                setMessage("");
              }}
              hierarchy={{
                type: "secondaryGrey",
                buttonText: "Cancel",
              }}
            />
            <Button
              size="lg"
              onClick={() => {
                postFeedback();
              }}
              hierarchy={{
                type: "primary",
                buttonText: "Save",
              }}
              disable={postLoading}
            />
          </div>
        </div>
      </Modal>
    </>
  );
};

const UploadFile = ({ attachments, handleDeleteAttachments }) => {
  return (
    <div className="student-feedback-attachments">
      {attachments &&
        attachments?.map((attachment) => (
          <div className="student-feedback-file-attachment-container">
            <div className="student-feedback-file-attachment-icon">
              <svg
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_1244_3355)">
                  <path
                    d="M10.7201 5.52502L6.12514 10.12C5.56222 10.6829 4.79874 10.9992 4.00265 10.9992C3.20655 10.9992 2.44307 10.6829 1.88014 10.12C1.31722 9.5571 1.00098 8.79361 1.00098 7.99752C1.00098 7.20143 1.31722 6.43794 1.88014 5.87502L6.47514 1.28002C6.85043 0.904739 7.35942 0.693909 7.89014 0.693909C8.42087 0.693909 8.92986 0.904739 9.30515 1.28002C9.68043 1.6553 9.89126 2.16429 9.89126 2.69502C9.89126 3.22575 9.68043 3.73474 9.30515 4.11002L4.70514 8.70502C4.5175 8.89266 4.26301 8.99808 3.99764 8.99808C3.73228 8.99808 3.47779 8.89266 3.29014 8.70502C3.1025 8.51738 2.99709 8.26288 2.99709 7.99752C2.99709 7.73216 3.1025 7.47766 3.29014 7.29002L7.53514 3.05002"
                    stroke="#344054"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_1244_3355">
                    <rect width="12" height="12" fill="white" />
                  </clipPath>
                </defs>
              </svg>
              <div>{`${
                attachment?.file.name.slice(0, 12) ??
                attachment?.name.slice(0, 12)
              }...`}</div>
            </div>
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              onClick={() => {
                handleDeleteAttachments(attachment.id);
                console.log("delete function clicked");
              }}
            >
              <path
                d="M12 4L4 12M4 4L12 12"
                stroke="#667085"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
        ))}
    </div>
  );
};

export default StudentsRemarks;
